// Core imports
import * as React from 'react';
import remove from 'lodash.remove';

// Components imports
import { Desktop, Mobile } from 'src/components/Invoices';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import DateRangeModel from 'src/model/dateRange.model';
import TablePaginator from 'src/components/common/TablePagination';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import {
  statusType,
  sortType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';

// Style and misc imports
import './InvoiceView.scss';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';

class InvoiceView extends React.Component<
  IInvoiceViewProps,
  IInvoiceViewState
> {
  constructor(props: IInvoiceViewProps) {
    super(props);

    this.state = {
      pageNumber: 0
    };
  }

  /* 
    handlePagination
   */
  private handlePagination = (type: 'next' | 'previous') => {
    const {
      datesFilter,
      statusFilter,
      orderFilter,
      sortFilter,
      invoiceFilter,
      nardFilter,
      orderNumberFilter,
      poNumberFilter,
      pagination
    } = this.props;
    const filters: IFiltersInvoice = {
      dateRange: datesFilter,
      status: statusFilter,
      orderStatus: orderFilter,
      sort: sortFilter,
      invoiceNumber: invoiceFilter,
      nardaNumber: nardFilter,
      orderNumber: orderNumberFilter,
      orderReference: poNumberFilter
    };

    if (type === 'previous') {
      if (pagination.pageNumber !== 0) {
        this.setState({ pageNumber: pagination.pageNumber - 1 }, () => {
          const newPagination = {
            page: this.state.pageNumber
          };
          this.props.getInvoices(filters, newPagination);
        });
      }
    } else {
      if (pagination.pageNumber !== pagination.totalPages) {
        this.setState({ pageNumber: pagination.pageNumber + 1 }, () => {
          const newPagination = {
            page: this.state.pageNumber
          };
          this.props.getInvoices(filters, newPagination);
        });
      }
    }
  };

  public componentDidMount = () => {
    // this.props.getArSummary();
    // const filters: IFiltersInvoice = {
    //   dateRange: null,
    //   status: null,
    //   sort: null
    // };
    // const pagination = {
    //   page: 0
    // };
    // this.props.getInvoices(filters, pagination);
  };

  public render() {
    const { t, invoiceContent, pagination } = this.props;

    return (
      <section id="rp-invoices">
        {/* <Breadcrumbs>
          {t('common.home')} / {t('accountMenuSidePanel.accountInfo')} /{' '}
          {t('invoices.invoice_plural')}{' '}
        </Breadcrumbs> */}
        {/* <h1 className="page-title">{t('invoices.invoice_plural')}</h1> */}
        <div className="invoices-container-desktop">
          <Desktop />
        </div>
        {/* <div className="invoices-container-mobile">
          <Mobile
          />
        </div> */}
        {/* <TablePaginator
          handlePagination={this.handlePagination}
          pagination={pagination}
        /> */}
      </section>
    );
  }
}

export default InvoiceView;

interface IInvoiceViewProps {
  setRegion(region: string): void;
  getUserAccounts(): void;
  getInvoices(filters: IFiltersInvoice, pagination: IPaginationInvoice): void;
  t: any;
  invoiceContent: InvoiceModel[];
  getInvoicesIsPending: boolean;
  datesFilter: DateRangeModel;
  statusFilter: statusType;
  orderFilter: orderType;
  invoiceFilter: invoiceType;
  nardFilter: nardType;
  orderNumberFilter: ordernumberType;
  poNumberFilter: poType;
  sortFilter: { type: sortType; order: 'asc' | 'desc' };
  pagination: {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
  userAccounts: any[];
  userAccountsIsPending: boolean;
  selectedInvoices: InvoiceModel[];
  isInvoiceActive: string[];
  getArSummary(): void;
  addSelectedInvoices: (invoices: InvoiceModel | InvoiceModel[]) => void;
  removeInvoiceFromSelected: (invoice: InvoiceModel) => void;
  clearSelectedInvoices: () => void;
  handlePagination: (type: any) => void;
}

interface IInvoiceViewState {
  pageNumber: number;
}
